import {Form as AntdForm} from "../../../__snowpack__/pkg/antd.js";
import _ from "../../../__snowpack__/pkg/lodash.js";
import {isFunction} from "../../../__snowpack__/pkg/lodash.js";
import React, {useContext} from "../../../__snowpack__/pkg/react.js";
import {GnFormContext} from "./index.js";
import prefabs from "./prefabs/index.js";
const UnknownPrefab = (prefabKey) => /* @__PURE__ */ React.createElement("span", {
  style: {color: "red"}
}, "[ Unknown Prefab Component: ", prefabKey, " ]");
const FormItem = (props) => {
  const context = useContext(GnFormContext);
  const {
    prefabKey,
    componentWrapper,
    componentProps,
    children,
    compact = context?.compact,
    style,
    ...resetProps
  } = props;
  let prefabComponent;
  let prefabFieldProps;
  let prefabComponentProps;
  let rewriteComponentProps;
  if (prefabKey) {
    const prefab = prefabs[prefabKey];
    prefabComponent = prefab?.component ?? (() => UnknownPrefab(prefabKey));
    prefabFieldProps = isFunction(prefab?.fieldProps) ? prefab.fieldProps(props, context) : prefab?.fieldProps;
    const {
      componentProps: _prefabComponentProps,
      rewriteComponentProps: _rewriteComponentProps,
      ..._prefabFieldProps
    } = prefabFieldProps ?? {};
    prefabFieldProps = _prefabFieldProps;
    prefabComponentProps = _prefabComponentProps;
    rewriteComponentProps = _rewriteComponentProps;
  }
  const wrappers = Array.isArray(componentWrapper) ? componentWrapper : _.compact([componentWrapper]);
  const handleWrappers = (component) => {
    return wrappers.reduce((_comp, wrapper) => {
      if (typeof wrapper === "object") {
        return wrapper.wrapper(_comp, ...wrapper.args ?? []);
      }
      return wrapper(_comp);
    }, component);
  };
  return /* @__PURE__ */ React.createElement(AntdForm.Item, {
    ...prefabFieldProps,
    ...resetProps,
    style: {
      marginBottom: compact ? 0 : void 0,
      ...prefabFieldProps?.style ?? {},
      ...style
    }
  }, prefabComponent ? React.createElement(componentWrapper ? handleWrappers(prefabComponent) : prefabComponent, {
    ...prefabComponentProps,
    ...componentProps,
    ...rewriteComponentProps,
    style: {
      ...prefabComponentProps?.style ?? {},
      ...componentProps?.style ?? {},
      ...rewriteComponentProps?.style ?? {}
    }
  }, children) : children);
};
export default FormItem;
